<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable class="bs-popup">
		<template v-if="details">
			<div class="bs-popup-head">
				<div class="bs-popup-tit">{{details.title}}</div>
			</div>
			<div class="bs-popup-scroll">
				<div class="bs-popup-body " >
					<div class="activity-content" v-html="details.content">
					</div>
					<!-- <div class="activity-bar">
						<div class="activity-icon">
							<img src="../../../assets/images/coupon.png" alt="" />
						</div>
						<div class="flex-col">
							<div class="title">优惠卷名称</div>
							<div class="desc">优惠细节</div>
						</div>
						<el-button type="primary" round class="get-button" >领取</el-button>
					</div> -->
					<div class="activity-foot">
						<div class="btn-coumster">
							<span class="iconfont icon-xiaoxi"></span>
						</div>
						<div class="flex-col">
							<el-button type="warning" @click="show = false" round class="cancle-button" >
								{{$t('取消')}}
							</el-button>
						</div>
					</div>
				</div>
			</div>
		</template>
	</van-popup>
	
</template>
<script>
	export default {
		components: {},
		props: {
			details: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return {
				show: false
			};
		},
		mounted() {}
	}
</script>
<style scoped>
	.activity-content{
		background-color: #FAF3EB;
		padding: 20px;
		border-radius: 10px;
		margin-bottom: 20px;
	}
	.activity-bar{
		display: flex;
		align-items: center;
		background: linear-gradient(-36deg, #C3A166, #93652E);
		border-radius: 14px;
		padding: 15px;
		margin-bottom: 20px;
		color: #fff;
		.get-button{
			width: 110px;
		}
		.activity-icon{
			width: 54px;
			height: 66px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
			background: linear-gradient(-49deg, #FAF2DE, #EAD8AE);
			border-radius: 7px;
			margin-right: 15px;
		}
		.desc{
			opacity: .5;
			font-size: 14px;
		}
	}
	.activity-foot{
		display: flex;
		align-items: center;
	}
	.cancle-button{
		width: 100%;
	}
	.btn-coumster{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 78px;
		height: 40px;
		background: #333333;
		color: #fff;
		cursor: pointer;
		border-radius: 20px 20px 20px 20px;
		margin-right: 10px;
		.iconfont{
			font-size: 20px;
		}
	}
	
	
	
	
	
</style>





